import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { productsApi } from '@/lib/api-client';

export interface PlatformSmsConfig {
  primarySmsNumber: string | null;
  backupSmsNumber: string | null;
  updatedAt: string | null;
  updatedBy: string | null;
}

const QUERY_KEY = ['platform-sms-config'] as const;

/** Super-admin: fetch the two platform-level SMS sender numbers (primary +
 *  backup). When unset, pos-backend falls back to env (and ultimately the
 *  hard-coded AWS defaults). */
export function usePlatformSmsConfig() {
  return useQuery<PlatformSmsConfig>({
    queryKey: QUERY_KEY,
    queryFn: () => productsApi.get<PlatformSmsConfig>('/admin/platform-sms-config'),
  });
}

/** Super-admin: update primary and/or backup platform SMS numbers. Accepts
 *  E.164 / 10-digit (server normalizes) or null to clear. pos-backend picks
 *  up the change within 30s (in-memory cache TTL). */
export function useUpdatePlatformSmsConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { primarySmsNumber?: string | null; backupSmsNumber?: string | null }) =>
      productsApi.put<PlatformSmsConfig>('/admin/platform-sms-config', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
